import { createContext } from 'react';

import { emptyTasksContext } from '@trqk/hooks';

export const TasksContext =
    createContext<TasksProviderValue>(emptyTasksContext);
